import { useCallback } from 'react';
import { Slide1Template } from '@/templates/Slide1Template';
import { TemplateOnScreenDisplay } from '../../components/TemplateOnScreenDisplay';
import { useUserData } from '@/contexts/UserDataContext';

interface PhotoSelectionStepProps {
    onNext: () => void;
}

export const PhotoSelectionStep = ({ onNext }: PhotoSelectionStepProps) => {
    const { updateUserData } = useUserData();

    const handlePhotoSelection = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];

        if (file) {
            // Validate file type
            if (!file.type.startsWith('image/')) {
                alert('Please select a valid image file.');
                return;
            }

            // Validate file size (e.g., max 10MB)
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (file.size > maxSize) {
                alert('Image file is too large. Please select an image smaller than 10MB.');
                return;
            }

            console.log('Photo selected:', file.name, 'Size:', file.size, 'Type:', file.type);
            updateUserData({ selectedPhoto: file });
            onNext();
        }
    }, [onNext, updateUserData]);

    return (
        <>
            <div className='flex flex-col justify-center items-center w-full overflow-y-auto overflow-x-hidden'>
                <TemplateOnScreenDisplay>
                    <Slide1Template showPicPlaceholder text1='' />
                </TemplateOnScreenDisplay>
            </div>
            <div className="w-full px-8">
                <label
                    htmlFor="photo-upload"
                    className="cursor-pointer w-full font-semibold transition-all rounded-[18px] bg-osHardBlack text-white hover:bg-osBlack h-[60px] flex items-center justify-center"
                >
                    Add Photo
                </label>
                <input
                    id="photo-upload"
                    type="file"
                    accept="image/*"
                    onChange={handlePhotoSelection}
                    className="hidden"
                />
            </div>
        </>
    );
};
